import { blocosAjuda, type ArtigoAjuda } from '../../lib/ajuda';
import '../../styles/ajuda.css';

export function ConteudoAjuda({ artigo, prefixoSecao }: { readonly artigo: ArtigoAjuda; readonly prefixoSecao?: string }) {
  return <div className="ajuda-texto">
    {blocosAjuda(artigo.texto).map((bloco, indice) => {
      if (bloco.tipo === 'titulo') return <h3 id={prefixoSecao ? `${prefixoSecao}-${indice}` : undefined} key={indice}>{bloco.texto}</h3>;
      if (bloco.tipo === 'subtitulo') return <h4 key={indice}>{bloco.texto}</h4>;
      if (bloco.tipo === 'paragrafo') return <p key={indice}>{bloco.texto}</p>;
      if (bloco.tipo === 'lista' || bloco.tipo === 'passos') {
        const Lista = bloco.tipo === 'passos' ? 'ol' : 'ul';
        return <Lista key={indice}>{bloco.itens.map((item, i) => <li key={i}>{item}</li>)}</Lista>;
      }
      return null;
    })}
  </div>;
}
